/* Native, click-to-load video stories; no external embeds or tracking requests. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const loops = new Map();
  function initLoops(scope = document) {
    scope.querySelectorAll('[data-ritual-loop], [data-care-loop]').forEach(video => {
      if (loops.has(video)) return;
      const button = video.closest('[data-loop-container], .film-card')?.querySelector('[data-loop-toggle]');
      if (!button) return;
      button.hidden = false;
      const label = button.dataset.loopLabel || 'balm demonstration';
      const state = { visible: false, manualPause: false };
      const canAuto = () => !reduced.matches && !navigator.connection?.saveData;
      function play() {
        const source = video.querySelector('source');
        if (!source.src) { source.src = source.dataset.src; video.load(); }
        video.play().catch(() => {});
      }
      function sync() {
        const visiblePanel = !video.closest('[data-gallery-panel]')?.hidden;
        if (state.visible && visiblePanel && !document.hidden && !state.manualPause && canAuto() && !document.querySelector('[data-video-modal][open]')) play();
        else video.pause();
      }
      const observer = new IntersectionObserver(entries => { state.visible = entries[0].isIntersecting; sync(); }, { threshold: .2 });
      observer.observe(video);
      video.addEventListener('play', () => { button.textContent = 'Ⅱ'; button.setAttribute('aria-label', `Pause ${label}`); });
      video.addEventListener('pause', () => { button.textContent = '▶'; button.setAttribute('aria-label', `Play ${label}`); });
      button.addEventListener('click', () => { if (video.paused) { state.manualPause = false; play(); } else { state.manualPause = true; video.pause(); } });
      loops.set(video, { sync, observer });
    });
  }
  function syncLoops() { loops.forEach((state, video) => { if (!video.isConnected) { state.observer.disconnect(); loops.delete(video); } else state.sync(); }); }
  initLoops();
  document.addEventListener('visibilitychange', syncLoops);
  reduced.addEventListener('change', syncLoops);
  document.addEventListener('lucy:gallery-changed', syncLoops);
  document.addEventListener('shopify:section:load', event => initLoops(event.target));
  document.addEventListener('shopify:section:unload', syncLoops);
  let opener;
  function closeVideo(dialog) { dialog.close(); }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-video-open]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      const dialog = document.querySelector('[data-video-modal]');
      if (!dialog || !dialog.showModal) return;
      event.preventDefault(); opener = link;
      const player = dialog.querySelector('[data-story-player]');
      const status = dialog.querySelector('[data-video-status]');
      dialog.querySelector('[data-video-heading]').textContent = link.dataset.videoTitle;
      const disclosure = dialog.querySelector('[data-video-disclosure-label]');
      disclosure.textContent = link.dataset.videoDisclosure || ''; disclosure.hidden = !disclosure.textContent;
      status.textContent = ''; player.replaceChildren();
      if (link.dataset.videoCaptions) {
        const track = document.createElement('track'); track.kind = 'captions'; track.srclang = 'en'; track.label = 'English (auto-generated)'; track.src = link.dataset.videoCaptions; player.append(track);
      }
      player.src = link.href; dialog.showModal(); syncLoops();
      player.play().catch(() => { status.textContent = 'Press play to watch the video.'; });
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.addEventListener('close', () => { player.pause(); player.removeAttribute('src'); player.replaceChildren(); player.load(); opener?.focus(); syncLoops(); });
        dialog.addEventListener('click', click => { const box = dialog.getBoundingClientRect(); if (click.target === dialog && (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom)) closeVideo(dialog); });
        player.addEventListener('error', () => { status.textContent = 'The video could not load. Please close it and try again.'; });
      }
    }
    const close = event.target.closest('[data-video-close]');
    if (close) closeVideo(close.closest('dialog'));
  });
})();
